import { Checkbox, Col, Form, Row, Input } from "antd";
import React, { useState } from "react";
import Selects from "../../../../biblio/Selects/Selects";
import Inputs from "../../../../biblio/Inputs/Inputs";
import { studyCosts } from "../../../../data/data";

const { TextArea } = Input;

interface EducationalStatusProps {
  academicLevel: any;
  academicYears: any;
  academicsPerformance: any;
  educational: any;
  form: any;
  index: number;
}

const EducationalStatus = ({
  academicLevel,
  academicYears,
  academicsPerformance,
  educational,
  form,
  index,
}: EducationalStatusProps) => {
  const [, setShowExtraInputs] = useState<boolean>(false);

  const handleCheckboxChange = (e: any) => {
    setShowExtraInputs(e.target.checked);
    form.setFieldValue(`is_continuing_education${index}`, e.target.checked);
  };
  return (
    <>
      <div className="takaful--title-tabs-sub">
        <span>الحالة التعليمية</span>
      </div>

      <Row gutter={16}>
        <Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
          <Form.Item
            name={`is_continuing_education${index}`}
            valuePropName={`is_continuing_education${index}`}
          >
            <Checkbox onChange={handleCheckboxChange}>
              <span className="takaful--check-style">
                هل مازال يتابع الدراسة ؟
              </span>
            </Checkbox>
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={16}>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`academic_level_id${index}`}
            label="المستوى الدراسي"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={academicLevel?.data} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`academic_year_id${index}`}
            label="السنة الدراسية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={academicYears} />
          </Form.Item>
        </Col>

        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`academic_performance_id${index}`}
            label="مستوى التحصيل"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={academicsPerformance} />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`educational_institution_type_id${index}`}
            label="نوع الجهة التعليمية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={educational} />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`educational_institution${index}`}
            label="الجهة التعليمية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="text" />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`educational_institution_mobile${index}`}
            label="هاتف الجهة التعليمية"
            rules={[
              {
                len: 10,
                message: "يجب ان يحتوي هاتف على 10 ارقام",
              },
            ]}
            labelCol={{ className: "takaful--label-style" }}
          >
            <Inputs type="tel" maxLength={10} />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`tuition_free${index}`}
            label="تكاليف الدراسة"
            labelCol={{ className: "takaful--label-style" }}
          >
            <Selects options={studyCosts} />
          </Form.Item>
        </Col>
        <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
          <Form.Item
            name={`educational_issues${index}`}
            label="المشكلات التعليمية"
            labelCol={{ className: "takaful--label-style" }}
          >
            <TextArea
              showCount
              maxLength={100}
              style={{ height: 70, resize: "none" }}
            />
          </Form.Item>
        </Col>
      </Row>
    </>
  );
};

export default EducationalStatus;
